import assert from 'assert-ts';
import type {Data, FieldRequired, FieldRequiredSimple} from '../types';

export const assertSimpleRequired = (
  field?: FieldRequired<Data, Data>,
): FieldRequiredSimple | undefined => {
  if (typeof field === 'boolean' || field === 'should' || field === undefined) {
    return field;
  }

  assert(
    false,
    'Support for FieldConditionalRequired here is not implemented yet.',
  );
};
